import { Timeline } from "antd";
import StepCard from "../stepCard/StepCard";

import { getPercent, getStatus, StepDot } from "./utils";
import { isUserIndevidual } from "../../../Utils";

const getOnboedingSteps = (navigate, userFlow) => {
  const steps = [
    {
      title: "Profile",
      description:
        "Fill out your profile for full interaction with the platform",
      button: {
        title: "Go to Settings",
        callback: () => {
          navigate("/settings");
        },
      },
      dot: (
        <StepDot
          stepDone={
            isUserIndevidual()
              ? userFlow?.onboarding?.completed_profile
              : userFlow?.onboarding?.completed_company_profile
          }
          firstItem={true}
        />
      ),
    },
    {
      title: "Identity",
      description: "Upload necessary KYB documents",
      button: {
        title: "Go to Settings",
        callback: () => {
          navigate("/settings");
        },
      },
      dot: <StepDot stepDone={userFlow?.onboarding?.verified_identity} />,
    },
    {
      title: "Services",
      description: "Select your services that you provide in the platform",
      button: {
        title: "Go to Settings",
        callback: () => {
          navigate("/settings");
        },
      },
      dot: <StepDot stepDone={userFlow?.onboarding?.visited_add_services} />,
    },
    {
      title: "SumSub",
      description:
        "Get verified with SumSub for more secure and faster KYB/KYC process",
      button: {
        title: "Go to Settings",
        callback: () => {
          navigate("/settings");
        },
      },
      dot: <StepDot stepDone={userFlow?.onboarding?.verified_sumsub} />,
    },
  ];
  if (isUserIndevidual()) {
    steps.splice(1, 1);
  }

  return steps;
};

export const facilitatorSteps = (userFlow, navigate, current) => [
  {
    title: "Explore InvestTech",
    status: getStatus(userFlow?.explore_investtech, current, 0),
    percent: getPercent(userFlow?.explore_investtech),
    content: (
      <Timeline mode="alternate">
        {[
          {
            title: "Service Marketplace",
            description:
              "Find and connect with platform users offering organizer and facilitator services",
            button: {
              title: "Go to Service Marketplace",
              callback: () => {
                navigate("/service-marketplace");
              },
            },
            dot: (
              <StepDot
                stepDone={
                  userFlow?.explore_investtech?.visited_service_marketplace
                }
                firstItem={true}
              />
            ),
          },
          {
            title: "Grant Marketplace",
            description:
              "Discover other grant opportunities for secure funding and support",
            button: {
              title: "Go to Grant Marketplace",
              callback: () => {
                navigate("/grant-marketplace");
              },
            },
            dot: (
              <StepDot
                stepDone={
                  userFlow?.explore_investtech?.visited_grant_marketplace
                }
              />
            ),
          },
          {
            title: "InvestTech Marketplace",
            description: "Access all the fundraising deals",
            button: {
              title: "Go to InvestTech Marketplace",
              callback: () => {
                navigate("/");
              },
            },
            dot: (
              <StepDot
                stepDone={
                  userFlow?.explore_investtech?.visited_investtech_marketplace
                }
              />
            ),
          },
          {
            title: "Longevity Marketplace",
            description: "Discover Longevity products and services",
            button: {
              title: "Go to Longevity Marketplace",
              callback: () => {
                navigate("/longevity-marketplace");
              },
            },
            dot: (
              <StepDot
                stepDone={
                  userFlow?.explore_investtech?.visited_longevity_marketplace
                }
              />
            ),
          },
          {
            title: "IP Marketplace",
            description: "Explore and view Intellectual Property deals",
            button: {
              title: "Go to IP Marketplace",
              callback: () => {
                navigate("/ip-marketplace");
              },
            },
            dot: (
              <StepDot
                stepDone={userFlow?.explore_investtech?.visited_ip_marketplace}
              />
            ),
          },
          {
            title: "M&A Marketplace",
            description: "Explore and view Mergers & Acquisitions deals",
            button: {
              title: "Go to M&A Marketplace",
              callback: () => {
                navigate("/MAmarketplace");
              },
            },
            dot: (
              <StepDot
                stepDone={userFlow?.explore_investtech?.visited_m_and_a}
              />
            ),
          },
          {
            title: "Chat",
            description: "Get in touch with platform users",
            button: {
              title: "Go to Chat",
              callback: () => {
                navigate("/chat");
              },
            },
            dot: (
              <StepDot stepDone={userFlow?.explore_investtech?.visited_chat} />
            ),
          },
        ].map((el, index) => {
          return (
            <Timeline.Item dot={el?.dot}>
              <StepCard
                title={el?.title}
                description={el?.description}
                button={el?.button}
                index={index}
              />
            </Timeline.Item>
          );
        })}
      </Timeline>
    ),
  },
  {
    title: "Onboarding",
    status: getStatus(userFlow?.onboarding, current, 1),
    percent: getPercent(userFlow?.onboarding),
    content: (
      <Timeline mode="alternate">
        {getOnboedingSteps(navigate, userFlow).map((el, index) => {
          return (
            <Timeline.Item dot={el?.dot}>
              <StepCard
                title={el?.title}
                description={el?.description}
                button={el?.button}
                index={index}
              />
            </Timeline.Item>
          );
        })}
      </Timeline>
    ),
  },
];
